import { Component, Inject, OnInit } from '@angular/core';
import { StudentCounsellingReportService } from '../student-counselling-report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { delay, map, of, startWith } from 'rxjs';

@Component({
  selector: 'app-student-counselling-report-dialog',
  templateUrl: './student-counselling-report-dialog.component.html',
  styleUrls: ['./student-counselling-report-dialog.component.scss']
})
export class StudentCounsellingReportDialogComponent implements OnInit {
  counsellingReport!: any
  Academicyearlist: any[] = [];
  AcademicOptions: any;
  statelist: any;
  stateOptions: any;
  cityOptions: any;
  citylist: any;
  campuslist: any;
  campusOptions: any;
  stateId: any;
  cityId: any;
  counserlerlist: any;
  counserlistOptions: any;
  Reasonslist: any;
  // issueslist: any;
  issueslist: any;
  ReasonsOptions: any;
  IdentifiedOptions: any;
  reasonId: any;
  campusid: any;
  createby: any;
  allReasonCategoryData: any[];
  constructor(private verification: StudentCounsellingReportService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService, private route: ActivatedRoute, private dialog: MatDialog, private dialogRef: MatDialogRef<StudentCounsellingReportDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) { }
  ngOnInit(): void {
    // this.adapter.setLocale('en-GB');
    this.counsellingReport = new FormGroup({
      StateControl: new FormControl('', Validators.required),
      StateControl2: new FormControl('', Validators.required),
      Academic: new FormControl('', Validators.required),
      Academic12: new FormControl('', Validators.required),
      CampusControl: new FormControl('', Validators.required),
      CampusControl2: new FormControl('', Validators.required),
      cityControl: new FormControl('', Validators.required),
      cityControl12: new FormControl('', Validators.required),
      campusControl: new FormControl('', Validators.required),
      campusControl12: new FormControl('', Validators.required),
      selectedDate: new FormControl('', Validators.required),
      CounsellerControl: new FormControl('', Validators.required),
      CounsellerControl12: new FormControl('', Validators.required),
      ReasonsControl: new FormControl('', Validators.required),
      ReasonsControl2: new FormControl('', Validators.required),
      IdentifiedControl: new FormControl('', Validators.required),
      IdentifiedControl2: new FormControl('', Validators.required),

    });
    this.getAcademicyear()
    this.getreason()


    if (this.data) {
      this.getstates(); // always call this

      if (this.data.stateId) {
        this.getcity(this.data.stateId);
      }

      if (this.data.cityId) {
        this.getCampus(this.data.cityId);
      }
      if (this.data.campusId) {
        this.getconseller(this.data.campusId);
      }

      if (this.data.counselCatId) {
        this.getIssues(this.data.counselCatId)
      }

      this.counsellingReport.patchValue({
        Academic: this.data.academicYear || null,
        StateControl: this.data.stateId || null,
        cityControl: this.data.cityId || null,
        campusControl: this.data.campusId || null,
        CounsellerControl: this.data.createdBy || null,
        ReasonsControl: this.data.counselCatId || null,
        IdentifiedControl: this.data.counselCategoryReasonIds || null


      });
    }
  }
  getAcademicyear() {
    this.verification.getacademic().subscribe(res => {
      // this.Academicyearlist=res
      this.Academicyearlist = (res as string[]).map((year: string) => ({ year: year }))
      this.AcademicOptions = this.counsellingReport.get('Academic12').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.Academicyearlist, 'year'))
      );
    })
  }
  onAcademicYearChange(selectedYear: string) {
    console.log("Selected year:", selectedYear);
    this.getstates();
  }
  // private Filter(value: string, list: any[], name: string): any[] {
  //   const searchValue = value?.trim().toLocaleLowerCase() ?? '';

  //   return list.filter((item: any) => {
  //     console.log('Checking:', item[name]);
  //     const target = item[name]?.toString().trim().toLocaleLowerCase() ?? '';
  //     return target.includes(searchValue);
  //   });
  // }

  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }
  getCampus1(e: any) {

  }

  getCampus(e: any) {
    this.cityId = typeof e === 'object' ? e.cityId : e;
    this.verification.getcampus(this.cityId).subscribe(res => {
      this.campuslist = res
      this.campusOptions = this.counsellingReport.get('CampusControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campuslist, 'campusName'))
      );
      this.checkAndFetchReasons()
    })
  }
  getReport() {
    //  this.checkFieldsIndividually()
    const form = this.counsellingReport.value;
    if (!form.Academic) {
      alert('Please select Academic Year');
      return;
    } else if (!form.StateControl) {
      alert('Please select State');
      return;
    } else if (!form.cityControl) {
      alert('Please select City');
      return;
    }


    const paramsObj: any = {
      academicYear: form.Academic,
      stateId: this.stateId,
      cityId: this.cityId,
      campusId: form.campusControl || '',
      createdBy: form.CounsellerControl || '',
      counselCatId: form.ReasonsControl || '',
      counselCategoryReasonIds: form.IdentifiedControl || '',

    };
    this.dialogRef.close({ params: paramsObj });
    // const formValues = this.counsellingReport.value;
    // const paramsObj: any = {
    //   academicYear: formValues.Academic,               
    //   stateId: formValues.StateControl,             
    //   cityId: formValues.cityControl,                  
    //   campusId: formValues.campusControl || '',        
    //   createdBy: formValues.CounsellerControl || '', 
    //   counselCatId: formValues.ReasonsControl || '',
    //   counselCategoryReasonIds: formValues.IdentifiedControl || '',       
    //   selectedDate: formValues.selectedDate || ''       
    // };
    // this.dialogRef.close({ params: paramsObj });
  }
  getconseller(e: any) {
    this.campusid = typeof e === 'object' ? e.campusId : e;
    this.verification.getcounseller(this.campusid).subscribe(res => {
      this.counserlerlist = res
      this.counserlistOptions = this.counsellingReport.get('CounsellerControl12').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.counserlerlist, 'empName'))
      );
      if (!this.Reasonslist || this.Reasonslist.length === 0) {
        this.checkAndFetchReasons()
      }
    })

  }

  getreasonss(empId: any) {

    this.createby = typeof empId === 'object' ? empId.empId : empId;
    if (this.createby) {
      this.checkAndFetchReasons();
    }

  }
  //  getIssues(e:any){
  //   this.reasonId = typeof e === 'object' ? e.counselCatId : e;
  //   if(this.reasonId){
  //     this.checkAndFetchReasons();
  //    }

  //  }
  getcity(e: any) {
    this.stateId = typeof e === 'object' ? e.stateId : e;
    this.verification.getcity(this.stateId).subscribe(res => {
      this.citylist = res
      this.cityOptions = this.counsellingReport.get('cityControl12').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.citylist, 'cityName'))
      );
      this.checkAndFetchReasons()
    })
  }
  getstates() {
    this.verification.getstate().subscribe(res => {
      this.statelist = res
      this.stateOptions = this.counsellingReport.get('StateControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.statelist, 'stateName'))
      );
    })
  }
  getreason() {
    this.verification.getreasons().subscribe(res => {
      this.Reasonslist = res
      this.ReasonsOptions = this.counsellingReport.get('ReasonsControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.Reasonslist, 'type'))
      );
    })
  }
  // getissues(e: any) {
  //   this.reasonId = typeof e === 'object' ? e.counselCatId : e;
  //   this.verification.getidentifiyiuess(this.reasonId).subscribe(res => {
  //     this.issueslist = res
  //     this.IdentifiedOptions = this.counsellingReport.get('IdentifiedControl2').valueChanges.pipe(
  //       startWith(''),
  //       map((value: any) => this.Filter(value, this.issueslist, 'reasonName'))
  //     );
  //   })
  // }


  checkAndFetchReasons() {
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId = this.cityId;
    const campusId = this.campusid;
    const counsellorId = this.createby;

    if (academicYear && cityId) {
      this.getReasonsAndIssues();
    }
  }

  getReasonsAndIssues() {
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId = this.cityId
    const campusId = this.campusid
    const counsellorId = this.createby
    this.verification.getCategoryDetails({ academicYear, cityId, campusId, counsellorId, }).subscribe((res: any) => {
      const allCategories = Array.isArray(res?.categoryDetails) ? res.categoryDetails : [];
      this.Reasonslist = allCategories.map((cat: any) => ({
        counselCatId: cat.counselCatId,
        type: cat.categoryName
      }));

      this.ReasonsOptions = this.counsellingReport.get('ReasonsControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.Reasonslist, 'type'))
      );


      this.allReasonCategoryData = allCategories;
    });
  }
  getIssues(e: any) {
    this.reasonId = typeof e === 'object' ? e.counselCatId : e;

    this.counsellingReport.get('IdentifiedControl2')?.reset();
    this.IdentifiedOptions = of([]);

    if (!this.reasonId) return;
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId = this.cityId;
    const campusId = this.campusid;
    const counsellorId = this.createby;
    const counselCatId = this.reasonId;
 const params = {
  academicYear: academicYear || this.data.academicYear,
  cityId: cityId || this.data.cityId,
  campusId: campusId || this.data.campusId,
  counsellorId: counsellorId || this.data.createdBy,
  counselCatId: counselCatId || this.data.counselCatId
};
    this.verification.getCategoryDetails(params).subscribe((res: any) => {
      const selectedCategory = res?.categoryDetails?.find(
        (cat: any) => cat.counselCatId == this.reasonId
      );

      // ✅ FIXED LINE:
      this.issueslist = selectedCategory?.categoryReasons || [];

      this.IdentifiedOptions = this.counsellingReport.get('IdentifiedControl2')?.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.issueslist, 'reasonName'))
      );
    });
  }


  checkFieldsIndividually() {
    const form = this.counsellingReport.value;
    if (!form.Academic) {
      alert('Please select Academic Year');
      return;
    } else if (!form.StateControl) {
      alert('Please select State');
      return;
    } else if (!form.cityControl) {
      alert('Please select City');
      return;
    }
  }

  clearCity() {
    this.counsellingReport.get('cityControl')?.reset();
    this.cityOptions = of([]).pipe(delay(0));
    this.citylist = '';
    this.clearCampus();
  }

  clearCampus() {
    this.counsellingReport.get('campusControl')?.reset();
    this.campusOptions = of([]).pipe(delay(0));
    this.campuslist = '';
    this.clearCounsler();
  }

  clearCounsler() {
    this.counsellingReport.get('CounsellerControl')?.reset();
    this.counserlistOptions = of([]).pipe(delay(0));
    this.counserlerlist = '';
    this.clearReason();
  }

  clearReason() {
    this.counsellingReport.get('ReasonsControl')?.reset();
    this.ReasonsOptions = of([]).pipe(delay(0));
    this.Reasonslist = '';
    this.clearIdentification();
  }

  clearIdentification() {
    this.counsellingReport.get('IdentifiedControl')?.reset();
    this.issueslist = [];
  }
}
